module.exports = __webpack_public_path__ + "img/microphone.8881499b.svg";